// Theme inspired by Spore.fun with Injective branding
export const darkTheme = {
  // Base colors
  background: '#030712',
  backgroundSecondary: '#0f172a',
  backgroundTertiary: '#1e293b',
  text: '#f8fafc',
  textSecondary: '#94a3b8',
  textTertiary: '#64748b',
  
  // Brand colors
  primary: '#7C3AED', // Injective purple
  primaryHover: '#8B5CF6',
  secondary: '#10B981', // Success green
  secondaryHover: '#34D399',
  accent: '#F59E0B', // Warning/alert
  accentHover: '#FBBF24',
  danger: '#EF4444', // Error/danger
  dangerHover: '#F87171',
  
  // UI elements
  border: '#1e293b',
  borderHover: '#334155',
  card: 'rgba(15, 23, 42, 0.6)',
  cardHover: 'rgba(15, 23, 42, 0.8)',
  scrollTrack: '#0f172a',
  scrollThumb: '#334155',
  scrollThumbHover: '#475569',
  
  // Status colors
  alive: '#10B981',
  breeding: '#F59E0B',
  dead: '#EF4444',
  
  // Generation colors (for family tree)
  gen1: '#7C3AED', // Injective purple
  gen2: '#8B5CF6',
  gen3: '#A78BFA',
  gen4: '#C4B5FD',
  gen5: '#DDD6FE',
  
  // Gradients
  gradientPrimary: 'linear-gradient(135deg, #7C3AED 0%, #8B5CF6 100%)',
  gradientSecondary: 'linear-gradient(135deg, #10B981 0%, #34D399 100%)',
  gradientBackground: 'radial-gradient(circle at 50% 50%, #0f172a 0%, #030712 100%)',
  
  // Shadows
  shadowSm: '0 1px 2px rgba(0, 0, 0, 0.2)',
  shadowMd: '0 4px 6px rgba(0, 0, 0, 0.3)',
  shadowLg: '0 10px 15px rgba(0, 0, 0, 0.4)',
  
  // Animations
  transitionSpeed: '0.3s',
};

export const lightTheme = {
  // Base colors
  background: '#f8fafc',
  backgroundSecondary: '#f1f5f9',
  backgroundTertiary: '#e2e8f0',
  text: '#0f172a',
  textSecondary: '#334155',
  textTertiary: '#64748b',
  
  // Brand colors
  primary: '#7C3AED', // Injective purple
  primaryHover: '#8B5CF6',
  secondary: '#10B981', // Success green
  secondaryHover: '#34D399',
  accent: '#F59E0B', // Warning/alert
  accentHover: '#FBBF24',
  danger: '#EF4444', // Error/danger
  dangerHover: '#F87171',
  
  // UI elements
  border: '#e2e8f0',
  borderHover: '#cbd5e1',
  card: 'rgba(241, 245, 249, 0.8)',
  cardHover: 'rgba(241, 245, 249, 0.95)',
  scrollTrack: '#f1f5f9',
  scrollThumb: '#cbd5e1',
  scrollThumbHover: '#94a3b8',
  
  // Status colors
  alive: '#10B981',
  breeding: '#F59E0B',
  dead: '#EF4444',
  
  // Generation colors (for family tree)
  gen1: '#7C3AED', // Injective purple
  gen2: '#8B5CF6',
  gen3: '#A78BFA',
  gen4: '#C4B5FD',
  gen5: '#DDD6FE',
  
  // Gradients
  gradientPrimary: 'linear-gradient(135deg, #7C3AED 0%, #8B5CF6 100%)',
  gradientSecondary: 'linear-gradient(135deg, #10B981 0%, #34D399 100%)',
  gradientBackground: 'radial-gradient(circle at 50% 50%, #f1f5f9 0%, #f8fafc 100%)',
  
  // Shadows
  shadowSm: '0 1px 2px rgba(0, 0, 0, 0.05)',
  shadowMd: '0 4px 6px rgba(0, 0, 0, 0.1)',
  shadowLg: '0 10px 15px rgba(0, 0, 0, 0.1)',
  
  // Animations
  transitionSpeed: '0.3s',
};
